export default {
  init() {
    // JavaScript to be fired on the about us page
  },
  finalize() {
    
      $('.owl-carousel-partners').owlCarousel({
      
      loop: true,
      autoplay: true,
      autoplaySpeed: 800,
      autoplayTimeout: 2500,
      dots: false,
      autoplayHoverPause: true,
      responsive: {
        0 : {
        items: 1,
      },
    // breakpoint from 480 up
      480 : {
         items: 2,
      },
    // breakpoint from 768 up
    768 : {
        items: 3,
    },
    1000 : {
        items: 3,
    },
    1200 : {
        items: 4,
    },
    1750 : {
        items: 5,
    },
  },




     });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/partners.js